export default __webpack_public_path__ + "static/media/intro3.bc443dd0.mp3";